var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{staticClass:"border-1 border-secondary rounded",staticStyle:{"min-height":"0"},attrs:{"id":_vm.id,"options":_vm.uploadOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }